import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolActivityBasename } from "../tool-activity-basename";
import { toolInput } from "../tool-input";
import type { ToolActivityState } from "../tool-activity-state";

export function describeAttachFile(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const file = toolActivityBasename(toolInput.str(record.path));
  const subject = file ?? "a file";
  if (state.hasFailed) {
    return labelOnly(`Failed to deliver ${subject}`);
  }
  return labelOnly(
    state.isRunning ? `Delivering ${subject}` : `Delivered ${subject}`,
  );
}
